"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rocchetta-e-croce": {
    "b0539c4f": [{
      "hkey": "5475719a",
      "slug": "rocchetta-e-croce",
      "name": "Rocchetta e Croce",
      "primary": true,
      "skipSearch": false
    }],
    "loreto": [{
      "hkey": "5475719a",
      "slug": "rocchetta-e-croce",
      "name": "Rocchetta e Croce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40525cfe": [{
      "hkey": "5475719a",
      "slug": "rocchetta-e-croce",
      "name": "Rocchetta e Croce",
      "primary": true,
      "skipSearch": false
    }],
    "valdassano": [{
      "hkey": "5475719a",
      "slug": "rocchetta-e-croce",
      "name": "Rocchetta e Croce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;